import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./CustomLink.module.css";

export default function CustomLink({ href, children, className }) {
  return (
    <a href={href} className={classNames(className, styles.CustomLink)}>
      {children}
    </a>
  );
}

CustomLink.propTypes = {
  href: PropTypes.string,
  className: PropTypes.string,
};
